// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const FormWrapper = styled.div`
  padding: 1em;

  display: -ms-grid;
  -ms-grid-columns: (1fr 1em)[3] 1fr;
  -ms-grid-rows: auto 1em auto;

  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 1em;
  grid-template-areas:
    "rcn jobNumber contactCode submit"
    ".   .         .           clear";
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto;

  > .rcn {
    grid-area: rcn;
    -ms-grid-column: 1;
    -ms-grid-row: 1;
  }

  > .job-number {
    grid-area: jobNumber;
    -ms-grid-column: 3;
    -ms-grid-row: 1;
  }

  > .contact-code {
    grid-area: contactCode;
    -ms-grid-column: 5;
    -ms-grid-row: 1;
  }

  > .submit {
    grid-area: submit;
    -ms-grid-column: 7;
    -ms-grid-row: 1;

    margin-top: 1.3em;
  }

  > .clear {
    grid-area: clear;
    -ms-grid-column: 7;
    -ms-grid-row: 3;
  }
`
